import {Location} from '@angular/common';
import {Component, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'carm-main-header-lang-section-view',
  templateUrl: './main-header-lang-section-view.component.html',
  styleUrls: ['./main-header-lang-section-view.component.scss'],
})
export class MainHeaderLangSectionViewComponent implements OnInit {

  @Input() isLoggedIn: boolean;

  language: any;
  routePath: string;

  constructor(@Inject(LOCALE_ID) protected localeId: string, private activatedRoute: ActivatedRoute, private router: Router,
              private location: Location) {

    const eng = {code: 'en', label: 'English'};
    const fre = {code: 'fr', label: 'Français'};

    if (localeId === 'en') {
      this.setLocal(fre);
    } else if (localeId === 'fr') {
      this.setLocal(eng);
    } else {
      // This case is really only for dev when not defining the local
      this.setLocal(eng);
    }

    router.events.subscribe((val) => {
      if (location.path() !== '') {
        const n = location.path().indexOf('/', 0);
        this.routePath = location.path().substring(n);
      }
    });
  }

  setLocal(local: { code: string; label: string; }) {
    this.language = local;
  }

  ngOnInit() {
  }
}
